<template>
<div>
    <div class="video-page-wrap" :style="mainWrapClass">
        <div class="video-wrap" :style="videoWrapClass">
            <div class="video-bar"></div>
            <div class="video-comp">
                <video-component @open-modal="openModal" :orientation="orientation" :controller="items" :links="currentVideos" :loop-links="currentLoops" @chat='openChat' :style="videoCompClass"></video-component>
            </div>
            <div class="video-bar"></div>
        </div>
    </div>
    <div class="emoji-warp" v-if="showEmoji">
        <div class="inner-emoji-wrap">
          <div class="emote" v-for="(emote, i) in emojis" :key="i">
            <img
              :ref="emote.name"
              :src="emote.gif"
              @click="animationInit(emote)"
              draggable="false"
            />
          </div>
        </div>
      </div>
</div>
</template>

<script>
import VideoComponent from '@/components/video/VideoComponent'
import api from '@/api/'
import cssFix from '@/mixins/cssFix.js'
export default {
    mixins: [cssFix],
    components: {
        VideoComponent
    },
    props: {
        orientation:{
            type: Boolean
        },
        videoLinks: {
            type: Array
        }
    },
    data () {
        return {
            ws: {
                connection: null,
                messages: []
            },
            items: [],
            currentAnimations: 0,
            maxAnimationDuration: 2500,
            maxElementDelay: 300,
			emojis: [
				{
					img: this.$images.like,
					gif: this.$images.likeAnimation,
					name: 'like'
				},
				{
					img: this.$images.heart,
					gif: this.$images.heartAnimation,
					name: 'heart'
				},
				{
					img: this.$images.squint,
					gif: this.$images.squintAnimation,
					name: 'squint'
				},
				{
					img: this.$images.surprise,
					gif: this.$images.surpriseAnimation,
					name: 'surprise'
				},
				{
					img: this.$images.sad,
					gif: this.$images.sadAnimation,
					name: 'sad'
				},
				{
					img: this.$images.angry,
					gif: this.$images.angryAnimation,
					name: 'angry'
				},
			],
        }
    },
    computed: {
        currentVideos () {
          return this.videoLinks.filter(el => el.ltp_code === 'intr')
        },
        currentLoops () {
          return this.videoLinks.filter(el => el.ltp_code === 'intl')
        },
        showEmoji() {
          let show = Number(this.$store.getters.globalFairConfig.FC_EMOJI)
          console.log("show: ", show)
          return show ? true : false;
        }
    },
    mounted () {
        this.init();
        api.mixpanel({
            event: 'Home_Page_Viewed'
        });
        this.connectToWs();
        this.addLogicForCssFix();
    },
    beforeDestroy() {
        this.closeWS()
    },
    methods: {
      async init() {
        this.startLoading();
          let trasformApi = (arr) => {
              return arr[0].data;
          }
          try {
              let res = await api.getIntroElements();
              this.items = trasformApi(res.data.res)
          } catch (error) {
              this.handleError(error)
          } finally {
            this.stopLoading();
          }
      },
      openModal (link) {
          this.$emit('open-modal', link)
      },
      openChat() {
        this.EventBus.$emit('chatProp', {
            location: 'public'
          })
      },
      /* Novo - emojis */
          
      minMax (min, max) {
        return Math.floor(Math.random() * (max-min) + min)
      },

      getEmojiCoords(name){
        let e = this.$refs[name][0].getBoundingClientRect();
        let x = e.x + (e.width/2);
        let y = e.y - 5;
        let coords = {
          x,y
        }
        return coords;
      },
          
      animationInit(emote) {
        let coords = this.getEmojiCoords(emote.name);
        let context = emote.ws ? true : false;
        this.animationCheckBeforeTrigger(coords, emote, context)
      },
      animationCheckBeforeTrigger (coords, emote, context) {
        let sendAnimation = true;
        if (this.currentAnimations > 5) {
          if (context) return;
          else sendAnimation = false;
        }
        // We call the function createParticle 20 times
        for (let i = 0; i < 20; i++) {
          this.createParticle(coords.x, coords.y, emote.img);
        }
        if (sendAnimation && !context) {
          console.log(context);
          console.log('im being sent');
          this.sendEmote(emote);
        }
        this.currentAnimations++;
        let maxAnimationTime = this.maxAnimationDuration + this.maxElementDelay
        setTimeout(() => {
          this.currentAnimations--;
        }, maxAnimationTime);
      },
      createParticle(x, y, img) {
        // Create a custom particle element
        const particle = document.createElement("img");
        particle.classList.add("particle");
        // Append the element into the body
        particle.src = `${img}`;
        document.body.appendChild(particle);

        const size = this.minMax(5, 40);
        // Apply the size on each particle
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        
        // Generate a random x & y destination within a distance of -150px to 150px on X axis  
        // and from -250px to -300px on Y axis above the emote
        let xPrim = 150;
        let yPrim = 300;
        let q = 50;
        let deg = 45;
        const destinationX = x + this.minMax(-xPrim, xPrim);
        const destinationY = y - this.minMax(yPrim - q, yPrim);
        const rotationStart = this.minMax(-deg, deg)
        const rotationEnd = this.minMax(-deg*2, deg)
        // Store the animation in a variable because we will need it later
        const duration = this.minMax(1000, this.maxAnimationDuration)
        const delay = this.minMax(0, this.maxElementDelay);
        const animation = particle.animate(
          [
            {
              // Set the origin position of the particle
              // We offset the particle with half its size to center it around the mouse
              transform: `translate(-50%, -50%) translate(${x}px, ${y}px) rotate(${rotationStart}deg)`,
              opacity: 1,
            },
            {
              // We define the final coordinates as the second keyframe
              transform: `translate(${destinationX}px, ${destinationY}px) rotate(${rotationEnd}deg)`,
              opacity: 0,
            },
          ],
          {
            // Set a random duration from 500 to 1500ms
            duration: duration,
            easing: "ease-out",
            // Delay every particle with a random value of 200ms
            delay: delay,
          }
        );
        animation.onfinish = () => {
          particle.remove();
        };
        // fallback for safari which doesnt have onfinish event
        let max = this.maxAnimationDuration + this.maxElementDelay
        setTimeout(() => {
          if (particle)
            particle.remove();
        }, max);
      },
      processMsg(msg) {
        let getEmoteByWsMsg = (msg) => {
          for (let emote of this.emojis) {
            if (emote.name === msg.name) {
              emote = {
                ...emote,
                ...msg
              };
              return emote;
            }
          }
        }
        if (msg.key === this.getKey) {
          return;
        }
        let emote = getEmoteByWsMsg(msg);
        this.animationInit(emote);
      },
      sendEmote(emote) {
        let msg = {
          ws: true,
          name: emote.name,
          key: this.getKey
        }
        msg = JSON.stringify(msg);
        if (this.ws.connection.send)
          this.ws.connection.send(msg);
      },
      connectToWs() {
        let WSBase = window.location.origin.replace('https','wss');
        WSBase = WSBase.replace('http','ws');
        WSBase = WSBase.replace('localhost:8080', '117x122.mars-t.mars-hosting.com')
        const wsConnection = new WebSocket(`${WSBase}/api/conferences/${this.loc_id}/ws`);
        wsConnection.onopen = () => {
          this.ws.connection = wsConnection;
          console.log('Opened WS connection');
        }
        wsConnection.onmessage = (evt) => {
          let msg = JSON.parse(evt.data);
          this.processMsg(msg);
        }
        wsConnection.onerror = (err) => {
          console.log('ERROR:');
          console.warn(err);
        }
        wsConnection.onclose = (evt) => {
          console.log('CLOSE:');
          console.warn(evt);
          setTimeout(() => {
            this.connectToWs();
          }, 1000);
        }
      },
      closeWS() {
        if (this.ws.connection) {
          this.ws.connection.onclose = () => {};
          this.ws.connection.close();
        }
      }
    }
}
</script>

<style scoped lang="scss">
.video-page-wrap {
  .video-wrap {
    .video-comp {
      position: relative;
    }
  }
}
.emoji-warp {
  position: absolute;
  background: #c4c4c4;
  max-width: 50%;
  height: 50px;
  min-height: 30px;
  padding: 0 calc(min(4%, 20px));
  box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25);
  border-radius: 15px;
  bottom: 20px;
  left: 30px;
  .inner-emoji-wrap {
    display: flex;
    padding: 0 5%;
    background: #fff;
    border-radius: 10px;
    .emote {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 1;
      margin: 0 2px;
      overflow: hidden;
      object-fit: cover;
      width: 50px;
      height: 50px;
      img {
        user-select: none;
        &:hover {
          opacity: 0.7;
          cursor: pointer;
        }
        border-radius: 50%;
        height: auto;
        object-fit: cover;
      }
    }
  }
}
.particle {
  z-index: 99999;
  position: fixed;
  pointer-events: none;
  border-radius: 50%;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
